import { ThemeNames } from './ITheme.js';

var palette = {
  accent1Darkest: '',
  accent1Darker: '#00747B',
  accent1Dark: '#248476',
  accent1: '#00B5B4',
  accent1Light: '#00B5B4',
  accent1Lighter: '#5DCAB9',
  accent1Lightest: '#F1FAFA',
  accent2Darkest: '',
  accent2Darker: '',
  accent2Dark: '#462B6B',
  accent2: '#83589C',
  // This is a temp fix for a custom color
  // request from UX. We need to bring up
  // a sync plan with UX on updating these colors.
  accent2Light: '#1772AE',
  accent2Lighter: '',
  accent2Lightest: '',
  black: '#000000',
  errorDarkest: '',
  errorDarker: '',
  errorDark: '#A00000',
  error: '#A00000',
  errorLight: '#A00000',
  errorLighter: '',
  errorLightest: '#FFF2F4',
  grayDarkest: '#222222',
  grayDarker: '#23292E',
  grayDark: '#37424A',
  gray: '#555E64',
  grayLight: '#BFBFBF',
  grayLighter: '#DCDEE0',
  grayLightest: '#F2F4F6',
  inherit: 'inherit',
  primaryDarkest: '',
  primaryDarker: '#762135',
  primaryDark: '#A00000',
  primary: '#AD112B',
  primaryLight: '#E3232A',
  primaryLighter: '',
  primaryLightest: '',
  secondaryDarkest: '',
  secondaryDarker: '',
  secondaryDark: '#244F8B',
  secondary: '#036d9B',
  secondaryLight: '#2591CF',
  secondaryLighter: '#41C4E7',
  secondaryLightest: '#EDF6F8',
  successDarkest: '',
  successDarker: '',
  successDark: '#00642D',
  success: '#007A25',
  successLight: '',
  successLighter: '',
  successLightest: '#E8F5EB',
  warningDarkest: '',
  warningDarker: '',
  warningDark: '',
  warning: '#FF5D0F',
  warningLight: '#FBA51F',
  warningLighter: '',
  warningLightest: '#F8E9DF',
  white: '#ffffff'
};
var secureSiteTheme = {
  name: ThemeNames.secureSite,
  fontFamily: '"Roboto", helvetica, sans-serif',
  palette: palette,
  grid: {
    containerWidth: {
      small: '1190px',
      medium: '1290px',
      large: '1440px'
    },
    gutterSize: '7px'
  },
  border: {
    radius: {
      large: '12px',
      medium: '6px',
      small: '3px'
    },
    size: {
      large: '8px',
      medium: '2px',
      small: '1px'
    },
    style: 'solid'
  },
  boxShadowSecondary: '0 2px 3px rgba(0,0,0,.3)',
  boxShadow: {
    box: '0 2px 3px rgba(34, 34, 34, .3)',
    button: '0 2px 3px rgba(34, 34, 34, .3)',
    buttonFocus: '0 0 3px #1b75bb'
  },
  button: {
    primary: {
      actionStyle: {
        background: palette.secondaryLight,
        border: "1px solid ".concat(palette.secondaryLight)
      },
      bgColor: palette.secondaryDark,
      border: "solid 1px ".concat(palette.secondaryDark),
      borderColor: palette.white,
      disabled: {
        actionStyle: {},
        bgColor: palette.gray,
        borderColor: palette.gray,
        txtColor: palette.white
      },
      txtColor: palette.white
    },
    primaryAlt: {
      // NOTE: This does _not_ match the LFG pattern library.
      // If anyone asks, we need our sites to be 2.1 compliant!
      actionStyle: {
        background: palette.secondaryDark,
        border: "1px solid ".concat(palette.secondaryDark),
        color: palette.white
      },
      bgColor: palette.white,
      border: "solid 1px ".concat(palette.white),
      borderColor: palette.secondaryDark,
      disabled: {
        actionStyle: {},
        bgColor: palette.gray,
        borderColor: palette.gray,
        txtColor: palette.white
      },
      txtColor: palette.secondaryDark
    },
    secondary: {
      actionStyle: {
        border: "1px solid ".concat(palette.secondaryDark),
        boxShadow: "0 0 0 2px ".concat(palette.secondaryDark)
      },
      bgColor: palette.white,
      border: "1px solid  ".concat(palette.secondaryDark),
      borderColor: palette.secondaryDark,
      disabled: {
        actionStyle: {},
        bgColor: palette.white,
        borderColor: palette.gray,
        txtColor: palette.gray
      },
      txtColor: palette.secondaryDark
    },
    text: {
      actionStyle: {},
      bgColor: 'transparent',
      border: 'none',
      borderColor: 'transparent',
      disabled: {
        actionStyle: {},
        bgColor: 'transparent',
        borderColor: 'transparent',
        txtColor: palette.gray
      },
      txtColor: palette.secondaryDark
    },
    white: {
      actionStyle: {
        border: "solid 2px ".concat(palette.white)
      },
      bgColor: 'transparent',
      border: 'solid 1px transparent',
      borderColor: palette.white,
      disabled: {
        actionStyle: {},
        bgColor: palette.white,
        borderColor: palette.gray,
        txtColor: palette.gray
      },
      txtColor: palette.white
    }
  },
  stepper: {
    step: {
      active: {
        backgroundColor: palette.secondaryDark,
        borderColor: palette.secondaryDark,
        color: palette.white,
        borderLeft: "0.3rem solid ".concat(palette.secondaryDark),
        borderBottom: "0.9rem solid ".concat(palette.secondaryDark),
        borderTop: "0.9rem solid ".concat(palette.secondaryDark)
      },
      completed: {
        backgroundColor: palette.primary,
        borderColor: palette.primary,
        color: palette.white,
        borderLeft: "0.3rem solid ".concat(palette.primary),
        borderBottom: "0.9rem solid ".concat(palette.primary),
        borderTop: "0.9rem solid ".concat(palette.primary)
      }
    }
  },
  link: {
    color: palette.secondaryDark
  },
  fontSize: {
    large: '18px',
    medium: '16px',
    small: '12px'
  },
  headings: {
    fontFamily: '"Publico", "Times New Roman", serif'
  },
  input: {
    backgroundColor: 'white',
    focusBorderColor: 'secondaryLighter'
  },
  table: {
    backgroundColor: 'white',
    cellPaddingTop: '0.625rem',
    cellPaddingRight: '1.5625rem',
    cellPaddingBottom: '0.625rem',
    cellPaddingLeft: '0.8125rem',
    rowBandingColor: 'grayLightest',
    borderColor: 'grayLighter',
    borderStyle: 'solid',
    borderWidth: '2px',
    fontSize: '0.875rem',
    header: {
      backgroundColor: 'grayDark',
      color: 'white',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'grayLighter',
      fontWeight: 500,
      textTransform: 'uppercase',
      subHeaderBackgroundColor: 'gray'
    }
  },
  tabs: {
    backgroundActive: palette.grayLightest,
    background: palette.white,
    borderActive: 'none',
    activeFontColor: 'primary',
    defaultFontColor: 'secondaryDark',
    hoverStyle: 'underline',
    fullWidth: true,
    containerBorder: 'none',
    containerPadding: '1rem 0',
    fontWeight: '500',
    borderTop: "1px solid ".concat(palette.grayLighter),
    borderBottom: "1px solid ".concat(palette.grayLighter),
    separator: {
      content: '',
      width: '1px',
      height: '25px',
      background: palette.grayLighter,
      position: 'absolute',
      right: '0',
      bottom: '9px'
    },
    mobileBackground: palette.grayLighter,
    mobileRadius: '.3rem',
    mobileBorder: "1px solid ".concat(palette.grayLighter),
    mobileDefaultFontColor: palette.black,
    mobileFontWeight: '400'
  },
  modal: {
    headerDividerColor: 'white',
    footerDividerColor: 'white',
    headerPadding: '1.875rem 0rem 0 0rem',
    footerPadding: '0 0 25px 0'
  }
};

export { secureSiteTheme };
